<template>
  <div class="empty-container flex flex-col justify-center items-center">
    <img src="~/assets/images/common/nodata.webp" alt="" />
    <slot name="default">
      <p class="text-14 text-color-lightgray">{{ emptyText }}</p>
    </slot>
  </div>
</template>

<script setup>
const props = defineProps({
  emptyText: {
    type: String,
    default: "未找到相关内容"
  },
});
</script>

<style lang="scss" scoped>
.empty-container {
  min-height: 300px;

  img {
    display: block;
  }
}
</style>
